export const toggleSpinner = (show = true) => {
  const spinner = document.getElementById('spinner');
  if(spinner){
    if(show){
      spinner.style.visibility = 'visible';
    } else {
      spinner.style.visibility = 'hidden';
    }
  }
}